import getMultiValueProperty from '../getMultiValueProperty';

/**
 * Returns a given root transform by it's style transform and it's dimensions as a svg transform attribute
 * @param {Object} rootStyle - The root style object
 * @param {RootPosition} rootPosition - The given root position
 * @returns {String}
 */
const getRootTransform = (rootStyle = {}, { top = 0, left = 0, height = 0, width = 0 } = {}) => {
    const { transform } = rootStyle;
    const rotateValue = transform && getMultiValueProperty(transform, 'rotate');
    if (!rotateValue) {
        return;
    }

    return `rotate(${rotateValue.replace('deg', '')} ${left + width / 2} ${top + height / 2})`;
};

export default getRootTransform;
